// @flow

import * as React from 'react';
import styles from './PickerPreview.less';

type Props = {
  /** The actual contents you would show such as current currency */
  children: React.Node,

  /** Show opened state or not */
  opened: boolean,
};

/**
 * The template for the picker preview, which shows the open/close and also takes
 * content (children) such as CurrencyPreviewContents.
 */
const PickerPreview = ({ children, opened }: Props) => (
  <div className={styles.container}>
    {children}
    {opened ? (
      <span className={`ui_icon caret-up ${styles.closeIcon}`} />
    ) : (
      <span className={`ui_icon caret-down ${styles.openIcon}`} />
    )}
  </div>
);

export default PickerPreview;
